import { render, staticRenderFns } from "./web3.vue?vue&type=template&id=4b464c2d&scoped=true"
import script from "./web3.vue?vue&type=script&lang=js"
export * from "./web3.vue?vue&type=script&lang=js"
import style0 from "./web3.vue?vue&type=style&index=0&id=4b464c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b464c2d",
  null
  
)

export default component.exports